import React from 'react';
import { COLOR_HEX_MAP } from '../../cus-product-list.const';
import { CusProductListColorsSectionProps } from '../../cus-product-list.data';

const resolveSwatchColor = (value: string): string => {
    const key = value.trim().toLowerCase();
    return COLOR_HEX_MAP[key] ?? key;
};

export default function ColorSection({ colors, selectedValues, onSelectionChange, colorsFilterHeading }: CusProductListColorsSectionProps) {
    const [isCollapsed, setIsCollapsed] = React.useState(false);
    const selectedSet = React.useMemo(() => new Set(selectedValues ?? []), [selectedValues]);

    const toggleColor = (value: string) => {
        const next = new Set(selectedSet);
        next.has(value) ? next.delete(value) : next.add(value);
        onSelectionChange?.(Array.from(next));
    };

    return (
        <section className='bs-product-list-filters__section'>
            <button
                type='button'
                className='bs-product-list-filters__section__title'
                onClick={() => setIsCollapsed(prev => !prev)}
                aria-expanded={!isCollapsed}
            >
                {colorsFilterHeading}
                <span className='bs-product-list-filters__section__title__chevron' aria-hidden='true' />
            </button>
            <div className={`bs-product-list-filters__colors${isCollapsed ? ' --collapsed' : ''}`}>
                {colors.map(color => {
                    const isSelected = selectedSet.has(color.value);
                    return (
                        <button
                            key={color.value}
                            type='button'
                            className={`bs-product-list-filters__colors__swatch${isSelected ? ' --selected' : ''}`}
                            onClick={() => toggleColor(color.value)}
                            aria-pressed={isSelected}
                            aria-label={color.value}
                            title={color.value}
                            style={{ backgroundColor: resolveSwatchColor(color.value) }}
                        />
                    );
                })}
            </div>
        </section>
    );
}
